import { Bonocliente } from "./bonocliente";
import { Tienda } from "./tienda";

export class Cliente {
    id!: number;
    name!: string | null;
    email!: string | null;
    dni!: string | null;
    movil!: string | null;
    tlf!: string | null;
    address!: string | null;
    sex!: number | null;
    text!: string | null;
    bonoclientes!: Bonocliente[] | null;
    tiendaId!: number;
    bonocredits!: number | null;
    isClienteCero!: boolean | null;
    codCliente!: string | null;
    cdPostal!: number | null;
    activo!: boolean | null;

      constructor(init?: Partial<Cliente>) {
        Object.assign(this, init);
      }
}

export class ClienteResumen {
  id!: number;
  name!: string | null;
  email!: string | null;
  dni!: string | null;
  movil!: string | null;
  activo!: boolean | null;
  numBonoclientes!: number | null;

  constructor(init?: Partial<Cliente>) {
    Object.assign(this, init);
  }
}

export class FiltroBusquedaClientes {
  name!: string | null;
  dni!: string | null;
  movil!: string | null;
  orden!: string | null;
  activo!: boolean | null;

  constructor(init?: Partial<FiltroBusquedaClientes>) {
    Object.assign(this, init);
  }
}
